import { render, staticRenderFns } from "./DenunciationsInformationsHeader.vue?vue&type=template&id=ee1bae2a&scoped=true&"
import script from "./DenunciationsInformationsHeader.vue?vue&type=script&lang=js&"
export * from "./DenunciationsInformationsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationsInformationsHeader.vue?vue&type=style&index=0&id=ee1bae2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1bae2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
